import { useState, useEffect } from "react";
import { fieldType } from "../../../../types/form";
import { FlexRow } from "src/utils/flexLayouts";
import { twMerge } from "tailwind-merge";
import { TGDisclosure } from "../../TGDisclosure";
import { SubResetFilter } from "src/pages/DashboardPage/mytasks/meetingsPage/components/MeetingCard";
import { SearchUI } from "../../Search";
import { TooltipItem } from "src/utils/Tooltip";
import { InfoIcon } from "src/components/ui-icons/myTasks/info";
import { useAppSelector } from "src/hooks/redux";
import { selectCurrentUser } from "src/modules/users/selector";
import { selectItems } from "src/modules/spItems/selectors";
import { myTasksLocationsListName } from "src/api/config/myTasksLists.config";
import _ from "lodash";

type Props = {
    dataField: fieldType;
    onChange: (data: any) => void;
    errors?: any;
    value: any;
}

function Checkbox(props: Props) {
    const { dataField, onChange, errors, value } = props;
    const [search, setSearch] = useState("");
    const currentUser = useAppSelector((state) => selectCurrentUser(state));
    const [resetValue, setResetValue] = useState<any>([]);
    const collections: any = useAppSelector((state) => selectItems(state, myTasksLocationsListName));

    useEffect(() => {
        if (dataField.key === 'Location' && collections.length > 0 && Object.keys(currentUser).length > 0 && currentUser.id > 0) {
            let defaultLocationsIds: number[] = [];
            if (currentUser.isLocationAdminMyTasks || currentUser.isLocationEditorMyTasks) {
                if (Array.isArray(currentUser.isLocationAdminMyTasks) && currentUser.isLocationAdminMyTasks.length > 0) {
                    defaultLocationsIds = [...defaultLocationsIds, ...currentUser.isLocationAdminMyTasks];
                }
                if (Array.isArray(currentUser.isLocationEditorMyTasks) && currentUser.isLocationEditorMyTasks.length > 0) {
                    defaultLocationsIds = [...defaultLocationsIds, ...currentUser.isLocationEditorMyTasks];
                }
            }
            let unicDefaultLocationsIds: number[] = [..._.uniqWith(defaultLocationsIds, _.isEqual)];
            if (unicDefaultLocationsIds.length > 0) {
                setResetValue(unicDefaultLocationsIds.map(id => {
                    return { id: id, name: collections.find((collection: any) => collection.ID === id)['Title'], disabled: false }
                }))
            }
        }
    }, [dataField, currentUser, collections])

    return (
        <>
            {dataField.isFilter &&
                <TGDisclosure disabled={dataField.disabled} wrapperClassName={dataField.width} noticeIcon={dataField.noticeIcon && <TooltipItem wrapperClassName="flex" position="filter" className="left-[-240px]" tooltipsComponent={dataField.notice} tooltipsText="">
                    <>&nbsp;&nbsp;<InfoIcon /></>
                </TooltipItem>} title={dataField.title} count={value && value.length || 0}>
                    {dataField.searchInFilterCheckbox &&
                        <SearchUI placeholder="Найти..." defaultValue={search} onClick={setSearch} />
                    }
                    <div className="mt-2">
                        {!search && dataField.optionsInputs && dataField.optionsInputs.length > 0 && dataField.optionsInputs.filter((option: any) => !option.hide).map((option: any, idx: number) => (
                            <label
                                className={twMerge("flex cursor-pointer select-none text-black mb-[15px] sm:mb-2 text-[16px] sm:text-[14px]", option.disabled ? "text-[#888c94] cursor-not-allowed" : "")}
                            >
                                <div className="relative">
                                    <input id={option.id} value={option.name} disabled={option.disabled} type="checkbox" checked={value && value.filter((checkedOption: any) => checkedOption.id === option.id).length > 0 || false} onChange={(e) => {
                                        let newValue = [...value];
                                        if (newValue.length > 0 && newValue.find((f) => Number(f.id) === Number(e.target.id))) {
                                            const filtered = value.filter((n: any) => Number(n.id) !== Number(e.target.id));
                                            newValue = filtered;
                                        } else {
                                            newValue.push(option);
                                        }
                                        onChange(newValue);
                                    }} className="sr-only" />
                                    <div
                                        className={twMerge(
                                            "flex items-center justify-center w-5 h-5 mr-[10px] sm:mr-4 border rounded box border-stroke",
                                            dataField.disabled ? "border-gray3" : "",
                                            value && value.filter((checkedOption: any) => checkedOption.id === option.id).length > 0 && "border-[#012169]" || "",
                                        )}
                                    >
                                        <span className={twMerge(value && value.filter((checkedOption: any) => checkedOption.id === option.id).length > 0 && "opacity-100" || "opacity-0")}>
                                            <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M10.0915 0.951972L10.0867 0.946075L10.0813 0.940568C9.90076 0.753564 9.61034 0.753146 9.42927 0.939309L4.16201 6.22962L1.58507 3.63469C1.40401 3.44841 1.11351 3.44879 0.932892 3.63584C0.755703 3.81933 0.755703 4.10875 0.932892 4.29224L0.932878 4.29225L0.934851 4.29424L3.58046 6.95832C3.73676 7.11955 3.94983 7.2 4.1473 7.2C4.36196 7.2 4.55963 7.11773 4.71406 6.9584L10.0468 1.60234C10.2436 1.4199 10.2421 1.1339 10.0915 0.951972ZM4.2327 6.30081L4.2317 6.2998C4.23206 6.30015 4.23237 6.30049 4.23269 6.30082L4.2327 6.30081Z"
                                                    fill="#012169"
                                                    stroke="#012169"
                                                    strokeWidth="0.4"
                                                ></path>
                                            </svg>
                                        </span>
                                    </div>
                                </div>
                                {option.name}
                            </label>
                        ))}
                        {search && dataField.optionsInputs && dataField.optionsInputs.length > 0 && dataField.optionsInputs.filter((option: any) => option.name && option.name.toLowerCase().trim().indexOf(search.toLowerCase().trim()) !== -1 && !option.hide).map((option: any, idx: number) => (
                            <label
                                className={twMerge("flex cursor-pointer select-none text-black mb-2 w-fit", option.disabled ? "text-[#888c94] cursor-not-allowed" : "")}
                            >
                                <div className="relative">
                                    <input id={option.id} value={option.name} disabled={option.disabled} type="checkbox" checked={value && value.filter((checkedOption: any) => checkedOption.id === option.id).length > 0 || false} onChange={(e) => {
                                        let newValue = [...value];
                                        if (newValue.length > 0 && newValue.find((f) => Number(f.id) === Number(e.target.id))) {
                                            const filtered = value.filter((n: any) => Number(n.id) !== Number(e.target.id));
                                            newValue = filtered;
                                        } else {
                                            newValue.push(option);
                                        }
                                        onChange(newValue);
                                    }} className="sr-only" />
                                    <div
                                        className={twMerge(
                                            "flex items-center justify-center w-5 h-5 mr-4 border rounded box border-stroke",
                                            dataField.disabled ? "border-gray3" : "",
                                            value && value.filter((checkedOption: any) => checkedOption.id === option.id).length > 0 && "border-[#012169]" || "",
                                        )}
                                    >
                                        <span className={twMerge(value && value.filter((checkedOption: any) => checkedOption.id === option.id).length > 0 && "opacity-100" || "opacity-0")}>
                                            <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M10.0915 0.951972L10.0867 0.946075L10.0813 0.940568C9.90076 0.753564 9.61034 0.753146 9.42927 0.939309L4.16201 6.22962L1.58507 3.63469C1.40401 3.44841 1.11351 3.44879 0.932892 3.63584C0.755703 3.81933 0.755703 4.10875 0.932892 4.29224L0.932878 4.29225L0.934851 4.29424L3.58046 6.95832C3.73676 7.11955 3.94983 7.2 4.1473 7.2C4.36196 7.2 4.55963 7.11773 4.71406 6.9584L10.0468 1.60234C10.2436 1.4199 10.2421 1.1339 10.0915 0.951972ZM4.2327 6.30081L4.2317 6.2998C4.23206 6.30015 4.23237 6.30049 4.23269 6.30082L4.2327 6.30081Z"
                                                    fill="#012169"
                                                    stroke="#012169"
                                                    strokeWidth="0.4"
                                                ></path>
                                            </svg>
                                        </span>
                                    </div>
                                </div>
                                {option.name}
                            </label>
                        ))}
                    </div>
                    <SubResetFilter resetFilter={() => onChange(resetValue)} />
                </TGDisclosure> ||
                <div className={`${dataField.width} mb-5`}>
                    <label className="flex flex-row justify-between text-sm font-medium leading-6 text-gray-900">
                        <span className="flex flex-row items-center">{dataField.title} {dataField.noticeIcon && <TooltipItem wrapperClassName="flex w-[758px]" position="top-right" tooltipsComponent={dataField.notice} tooltipsText="">
                            <>&nbsp;&nbsp;<InfoIcon /></>
                        </TooltipItem>}</span>
                        {dataField.require && (
                            <div className="flex flex-row justify-between">
                                {Object.keys(errors).length > 0 && errors[dataField.key] && (
                                    <span className="text-[#BA0C2F]">Заполните поле&nbsp;</span>
                                )}
                                <span className="text-[#BA0C2F]">*</span>
                            </div>
                        )}
                    </label>
                    <div className="mt-2">
                        {dataField.optionsInputs && dataField.optionsInputs.length > 0 && dataField.optionsInputs.map((option: string, idx: number) => (
                            <label
                                className={twMerge("flex cursor-pointer select-none text-black mb-2 w-fit", dataField.disabled ? "text-[#888c94] cursor-not-allowed" : "")}
                            >
                                <div className="relative">
                                    <input value={option} disabled={dataField.disabled} type="checkbox" checked={value && value.filter((checkedOption: any) => checkedOption === option).length > 0 || false} onChange={(e) => {
                                        let newValue = [...value];
                                        if (newValue.length > 0 && newValue.find((f) => f === e.target.value)) {
                                            const filtered = value.filter((n: any) => n !== e.target.value);
                                            newValue = filtered;
                                        } else {
                                            newValue.push(e.target.value);
                                        }
                                        onChange(newValue);
                                    }} className="sr-only" />
                                    <div
                                        className={twMerge(
                                            "flex items-center justify-center w-5 h-5 mr-4 border rounded box border-stroke",
                                            dataField.disabled ? "border-gray3" : "",
                                            value && value.filter((checkedOption: any) => checkedOption === option).length > 0 && "border-[#012169]" || "",
                                        )}
                                    >
                                        <span className={twMerge(value && value.filter((checkedOption: any) => checkedOption === option).length > 0 && "opacity-100" || "opacity-0")}>
                                            <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M10.0915 0.951972L10.0867 0.946075L10.0813 0.940568C9.90076 0.753564 9.61034 0.753146 9.42927 0.939309L4.16201 6.22962L1.58507 3.63469C1.40401 3.44841 1.11351 3.44879 0.932892 3.63584C0.755703 3.81933 0.755703 4.10875 0.932892 4.29224L0.932878 4.29225L0.934851 4.29424L3.58046 6.95832C3.73676 7.11955 3.94983 7.2 4.1473 7.2C4.36196 7.2 4.55963 7.11773 4.71406 6.9584L10.0468 1.60234C10.2436 1.4199 10.2421 1.1339 10.0915 0.951972ZM4.2327 6.30081L4.2317 6.2998C4.23206 6.30015 4.23237 6.30049 4.23269 6.30082L4.2327 6.30081Z"
                                                    fill="#012169"
                                                    stroke="#012169"
                                                    strokeWidth="0.4"
                                                ></path>
                                            </svg>
                                        </span>
                                    </div>
                                </div>
                                {option}
                            </label>
                        ))}
                    </div>
                </div>
            }
        </>

    );
}

export default Checkbox;





